/**
 * Better Auth: GET /get-session devuelve `null` sin cookie válida (suele ser 200, no 401).
 * Solo consideramos sesión válida si hay `session` + `user` con `id` (evita objetos vacíos o JSON inesperado).
 */
export function hasValidAuthSession(data: unknown): boolean {
  if (data == null || typeof data !== "object") {
    return false;
  }
  const row = data as { user?: unknown; session?: unknown };
  if (row.session == null || typeof row.session !== "object") {
    return false;
  }
  if (row.user == null || typeof row.user !== "object") {
    return false;
  }
  const id = (row.user as { id?: unknown }).id;
  return typeof id === "string" && id.length > 0;
}
